module.exports = __webpack_public_path__ + "static/media/afinando_tint_purple.281d91aa.svg";